export enum SMSDeliveryStatus {
  Pending = "Pending",
  Delivered = "Delivered",
  Expired = "Expired",
  Error = "Error",
  Rejected = "Rejected",
  Unknown = "Unknown"
}
